module.exports = __webpack_public_path__ + "static/media/MusicDetailsScreen_elRules_209111.b7023568.jpg";